<div class="page-title-area">
    <div class="d-table">
        <div class="d-table-cell">
            <div class="container">
                <div class="page-title-text">
                    <h2>Log In</h2>
                    <ul>
                        <li><a routerLink="/">Home</a></li>
                        <li><i class="icofont-simple-right"></i></li>
                        <li>Log In</li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="login-area pt-100 col-lg-3 mx-auto">
    <div class="container">
        <h2>Ingresá den bo kuenta.</h2>

        <form [formGroup]="loginForm" (ngSubmit)="onSubmit()">
            <div *ngIf="errorMessage" class="alert alert-danger">
                {{ errorMessage }}
              </div>
            <div class="form-group">
                <input type="email" class="form-control" placeholder="Email" formControlName="email">
                <div *ngIf="loginForm.get('email').errors && loginForm.get('email').touched" class="alert alert-danger">
                    <!-- Add specific error messages here -->
                    Email is required and must be a valid email.
                </div>
            </div>

            <div class="form-group">
                <input type="password" class="form-control" placeholder="Password" formControlName="password">
                <div *ngIf="loginForm.get('password').errors && loginForm.get('password').touched" class="alert alert-danger">
                    Password is required.
                </div>
            </div>

            <div class="text-center">
                <button type="submit" class="btn create-ac-btn" [disabled]="loginForm.invalid">Log In</button>
            </div>
        </form>

        <div class="login-sign-in">
           <!--- <a routerLink="/">Forgot Password?</a> -->
            <ul>
                <li>Bo no tin un kuenta ?</li>
                <li><a routerLink="/create-account">Registrá aki</a></li>
            </ul>
            <ul>
                <li><a routerLink="/forgot-password">Mi a lubida mi kodigo sekreto.</a></li>
            </ul>
        </div>
    </div>
</div>
